import {Layout, Typography, Anchor} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import FutureLogic from './FutureDirectionsLogic';
import FuturePart2 from './FuturePart2';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;

const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};
const FuturePage = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');

  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#HPFuture') {
      setBackI(appColors['ColorF']);
      setBackII('transparent');
    } else {
      setBackI('transparent');
      setBackII(appColors['ColorF']);
    }
  };

  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#HPFuture' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorF'], fontSize: '2.4vh'}}>Future Directions</Text></Content>}/>
          <Link href='#Future2' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorF'], fontSize: '3vh'}}>Conclusions</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorF'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> F&nbsp;<br/> U&nbsp;<br/> T&nbsp;<br/> U&nbsp;<br/> R&nbsp;<br/> E&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='HPFuture'>
              <FutureLogic/>
            </div>
            <div id='Future2'>
              <FuturePart2/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default FuturePage;
